import styled from "@emotion/styled";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";
import { TextField } from "src/components/Default/LekUI/TextField";
import { useGetSpecialisations, useSetSpecialisation } from "src/hooks/useUser";
import newApi from "src/newApi";

import { useGetCountOfUnresolvedComments } from "../../../hooks/useNotifications";
import Filter from "./DefaultFilters";

const FormControlLabel = styled(MUIFormControlLabel)`
  width: 100%;

  .MuiCheckbox-root {
    padding: 2px 8px;
  }
`;

const Text = styled("span")`
  font-size: 12px;
`;

const UnresolvedText = styled(Text)`
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export default function SpecialisationsFilter(props) {
	const { mutateAsync } = useSetSpecialisation();
	const [searchText, setSearchText] = useState("");

	const userSpecId = newApi.getUserSpecialization();
	const { t } = useTranslation();
	const { data: specializations } = useGetSpecialisations();
	const { data: specCounts } = useGetCountOfUnresolvedComments();

	const setSelectedType = async (id) => {
		if (id !== userSpecId) {
			await mutateAsync({ id });
			location.reload();
		}
	};

	const getLabelNode = (id, text) => {
		const spec = specCounts.find(({ specId }) => specId === id);
		const count = spec?.count || 0;

		if (count === 0) {
			return <Text>{`${text} (${count})`}</Text>;
		}

		return <UnresolvedText>{`${text} (${count})`}</UnresolvedText>;
	};

	const renderFilter = (type, text) => {
		return (
			<FormControlLabel
				label={getLabelNode(type, text)}
				control={
					<Checkbox
						size="small"
						checked={userSpecId === type}
						onChange={() => setSelectedType(type)}
					/>
				}
			/>
		);
	};

	const renderSearch = () => {
		return (
			<TextField
				variant="outlined"
				margin="none"
				fullWidth
				label={t("filters.exams.departments.search")}
				value={searchText}
				onChange={(e) => setSearchText(e.target.value)}
				size="small"
			/>
		);
	};

	const renderFilters = () => {
		if (!specializations || !specCounts) {
			return null;
		}

		return (
			<div>
				{renderSearch()}
				{specializations
					.filter((s) =>
						s.specialisation.toLowerCase().startsWith(searchText.toLowerCase()),
					)
					.map((spec) => renderFilter(spec.id, spec.specialisation))}
			</div>
		);
	};

	return (
		<Filter
			{...props}
			title={t("filters.exams.specialisations.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
